export default __webpack_public_path__ + "static/apple_consultants_network-570428f63cd552df1221c3fd80496b15.png";